<template>
  <v-app>
    <v-container fluid grid-list-lg>
      <v-card>
        <v-toolbar>
          <v-icon>playlist_add_check</v-icon>
          <v-toolbar-title class="font-weight-light"
            >&nbsp;Bandeja de Créditos Otorgados</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                icon
                color="red"
                v-on="on"
                @click="setStatusTareaFrecuente(action)"
              >
                <v-icon v-if="action.esFrecuente">favorite</v-icon>
                <v-icon v-else>favorite_border</v-icon>
              </v-btn>
            </template>
            <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
            <span v-else>Agregar a Tareas Frecuentes</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-layout row>
            <v-flex xs12 sm6 md2 lg2>
              <v-autocomplete
                v-model="filtro.sucursalId"
                :items="sucursales"
                item-text="nombre"
                item-value="id"
                label="Solicitudes de la Sucursal:"
                placeholder="Seleccione una"
                :menu-props="{ minWidth: '400' }"
              ></v-autocomplete>
            </v-flex>
            <!-- COMENTADO POR CAMBIO DE SELECT
           <v-flex xs12 sm6 md3 lg3>
              <v-autocomplete
                v-model="filtro.canalVentaId"
                :items="canalesVenta"
                item-text="nombre"
                item-value="id"
                label="Originadas en:"
                placeholder="Seleccione un Canal de Venta"
                :menu-props="{ minWidth: '400' }"
              ></v-autocomplete>
            </v-flex> -->

            <v-flex xs12 sm6 md1 lg1 fluid v-if="muestraFiltroCanalesVenta">
              <v-checkbox
                v-model="cargaCanalesVenta"
                label="Filtrar Canales"
                :disabled="loading"
                @click="cargarCanalesVenta"
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3 v-if="cargaCanalesVenta">
              <v-autocomplete
                label="Originadas en:"
                v-model="filtro.canalesVenta"
                :items="canalesVenta"
                item-text="nombre"
                item-value="id"
                multiple
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="toggleCanalesVenta">
                    <v-list-item-action>
                      <v-icon
                        :color="
                          filtro.canalesVenta.length > 0
                            ? 'indigo darken-4'
                            : ''
                        "
                        >{{ iconCanalesVenta }}</v-icon
                      >
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Marcar todos</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <!-- ARRIBA esto es para agregar la opción de select all -->
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index <= 2">
                    <span>{{ item.nombre }}</span>
                  </v-chip>
                  <span v-if="index === 3" class="grey--text caption"
                    >(+{{ filtro.canalesVenta.length - 3 }} más)</span
                  >
                </template>
              </v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md3 l3>
              <v-autocomplete
                v-model="filtro.productoId"
                :items="productos"
                item-text="descripcion"
                item-value="id"
                label="Del producto:"
                placeholder="Seleccione uno"
                :menu-props="{ minWidth: '400' }"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3>
              <app-selector-periodos
                v-on:update-periodo="filtro.periodo = $event"
                :column="true"
              ></app-selector-periodos>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12 sm6 md3 lg3>
              <v-text-field
                v-model="filtro.documento"
                label="Buscar por documento"
              >
              </v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3>
              <v-select
                label="En estados:"
                v-model="filtro.subestados"
                :items="subestados"
                item-text="descripcion"
                item-value="id"
                multiple
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="toggleSubestados">
                    <v-list-item-action>
                      <v-icon
                        :color="
                          filtro.subestados.length > 0 ? 'indigo darken-4' : ''
                        "
                        >{{ iconSubestados }}</v-icon
                      >
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Marcar todos</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <!-- ARRIBA esto es para agregar la opción de select all -->
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index <= 2">
                    <span>{{ item.descripcion }}</span>
                  </v-chip>
                  <span v-if="index === 3" class="grey--text caption"
                    >(+{{ filtro.subestados.length - 3 }} más)</span
                  >
                </template>
              </v-select>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3 fluid>
              <v-select
                label="Origen:"
                v-model="filtro.tipoCanalVentaId"
                :items="tiposCanalVenta"
                item-text="descripcion"
                item-value="id"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3 fluid>
              <v-select
                label="Estado Legajo Digital:"
                v-model="filtro.tipoEstadoLegajoDigitalId"
                :items="tiposEstadoLegajoDigital"
                item-text="descripcion"
                item-value="id"
              ></v-select>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12 sm6 md3 lg3 fluid>
              <v-select
                label="Estado del Producto Dirigido:"
                v-model="filtro.tipoEstadoProductoDirigidoId"
                :items="tiposEstadoProductoDirigido"
                item-text="descripcion"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md3 lg3 fluid>
              <v-checkbox
                v-model="filtro.filtrarUltimaActualizacion"
                label="Filtrar Última Actualización"
                :disabled="loading"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md3 lg3 fluid>
              <app-selector-periodos
                v-show="filtro.filtrarUltimaActualizacion"
                row
                v-on:update-periodo="filtro.periodoActualizacion = $event"
              ></app-selector-periodos>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm6 md3 lg3 fluid>
              <v-btn
                color="success"
                @click="getItems(true)"
                :disabled="deshabilitarConsultar"
                >Consultar</v-btn
              >
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex>
              <v-card>
                <v-toolbar :color="$store.state.UiColors.crudToolbarList">
                  <v-icon>list</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Resultados</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                  <v-switch
                    v-model="accionesMasivas"
                    label="Acciones Masivas"
                  ></v-switch>
                </v-toolbar>

                <v-data-table
                  dense
                  :headers="headers"
                  :items="records"
                  :server-items-length="totalItems"
                  :rows-per-page="pagination.rowsPerPage"
                  :options.sync="pagination"
                  v-model="selectedCreditos"
                  :loading="loading"
                  class="elevation-1"
                  :footer-props="footer"
                  :show-select="records.length > 0 && accionesMasivas"
                >
                  <template v-slot:no-data>
                    <v-alert
                      v-if="!primeraBusquedaRealizada"
                      :value="true"
                      color="grey lighten-3"
                      icon="info"
                    >
                      Ingrese los filtros para realizar la búsqueda
                    </v-alert>
                    <v-alert v-else :value="true" color="grey" icon="warning">
                      No se encontraron registros con los filtros ingresados
                    </v-alert>
                  </template>

                  <template v-slot:item="{ item, isSelected, select }">
                    <tr>
                      <td v-if="accionesMasivas == true">
                        <v-simple-checkbox
                          class="caption"
                          color="green"
                          :value="isSelected"
                          @input="select($event)"
                        ></v-simple-checkbox>
                      </td>

                      <td>
                        <app-acciones-comunes
                          :personaId="item.solicitanteId"
                          :documento="item.documento.toString()"
                          :solicitudId="item.id"
                          :ocultarAnalisisConsulta="true"
                          :showCompletarDocumentacion="
                            item.subEstado.includes('Falta')
                          "
                          :showCancelarAnalisis="
                            item.analista.includes('Tomado') &&
                              checkCanAccess('ap-forzar-cancelar-analisis')
                          "
                          @refrescar-lista="getItems(false)"
                        >
                        </app-acciones-comunes>
                      </td>

                      <td class="text-xs-left caption">
                        <tr>
                          {{
                            item.origen
                          }}
                        </tr>

                        <tr class="text-xs-left font-weight-light caption">
                          {{
                            item.producto
                          }}
                          /
                          {{
                            item.planNombre
                          }}
                        </tr>
                      </td>

                      <td
                        class="text-xs-left caption"
                        v-if="!habilitarCambioEstadoMasivo"
                      >
                        {{ item.subEstado }}
                      </td>

                      <!-- <td
                        class="text-xs-left caption"
                        v-if="item.origenId == 2">
                        {{ "APP" }}
                      </td>
                      <td class="text-xs-left caption" v-else>
                        {{ "Smarter" }}
                      </td> -->

                      <td>
                        <v-chip
                          v-if="item.origenId == 2"
                          small
                          color="orange"
                          text-color="white"
                          label
                          dark
                          >{{ 'APP' }}</v-chip
                        >
                        <v-chip
                          v-else
                          small
                          color="blue"
                          text-color="white"
                          label
                          dark
                          >{{ 'Smarter' }}</v-chip
                        >
                      </td>

                      <td
                        class="text-xs-left caption"
                        v-if="
                          $store.state.parametrosGenerales
                            .ingresoPorDefectoPor == 'documento'
                        "
                      >
                        {{ item.documento }}
                      </td>
                      <td class="text-xs-left caption" v-else>
                        {{ item.cuil }}
                      </td>

                      <td class="text-xs-left caption">
                        {{ item.solicitante }}
                      </td>
                      <td class="text-xs-left caption">{{ item.numero }}</td>
                      <td class="text-xs-left caption">
                        {{ item.monto | currency }}
                      </td>

                      <td class="text-xs-left caption">
                        <tr>
                          {{
                            item.cuotas
                          }}
                          de
                        </tr>
                        <tr>
                          {{
                            item.importeCuota | currency
                          }}
                        </tr>
                      </td>

                      <td class="text-xs-left caption">
                        {{
                          item.fechaIngreso
                            | dateParse('YYYY-MM-DD HH:mm:ss')
                            | dateFormat('DD-MM-YYYY HH:mm')
                        }}
                      </td>
                      <td
                        class="text-xs-left caption"
                        v-if="!habilitarCambioEstadoMasivo"
                      >
                        <span v-if="item.fechaLiquidacion"
                          >{{
                            item.fechaLiquidacion
                              | dateParse('YYYY-MM-DD')
                              | dateFormat('DD-MM-YYYY')
                          }}
                        </span>
                        <span v-else>-</span>
                      </td>

                      <td class="text-xs-left caption">{{ item.analista }}</td>

                      <td class="text-xs-left caption">
                        {{ item.motorSiisa }}
                        <v-chip
                          x-small
                          v-if="item.ejecucionMotorSiisaId > 0"
                          @click="
                            ejecucionMotorId = item.ejecucionMotorSiisaId;
                            showVariablesMotor = true;
                          "
                          >Ver</v-chip
                        >
                      </td>

                      <td class="text-xs-left caption">
                        {{ item.vieneDeGueno ? 'Si' : '' }}
                      </td>

                      <td
                        class="text-xs-left caption"
                        v-if="
                          $store.state.parametrosGenerales.auditoriaLegajoFisico
                        "
                      >
                        {{ item.estadoLegajoOriginal }}
                      </td>
                      <td
                        class="text-xs-left caption"
                        v-if="
                          $store.state.parametrosGenerales
                            .auditoriaLegajoDigital
                        "
                      >
                        {{ item.estadoValidacionDigital }}
                      </td>
                      <td class="text-xs-left caption">
                        {{ item.estadoProductoDirigido }}
                      </td>
                      <td class="text-xs-left caption">
                        {{ item.celular }}
                      </td>

                      <td
                        class="text-xs-left caption"
                        v-if="habilitarCambioEstadoMasivo"
                      >
                        {{ item.situacionCreditoDescripcion }}
                      </td>
                      <td
                        class="text-xs-left caption"
                        v-if="habilitarCambioEstadoMasivo"
                      >
                        {{ item.importeRenovacion | currency }}
                      </td>
                      <td
                        class="text-xs-left caption"
                        v-if="habilitarCambioEstadoMasivo"
                      >
                        {{ item.importeATransferir | currency }}
                      </td>

                      <td>
                        <app-impresion-formulario
                          :creditoId="item.id"
                          :empresaId="item.empresaId"
                          :productoDescripcion="item.producto"
                        ></app-impresion-formulario>
                      </td>

                      <td class="text-xs-left caption">
                        <v-chip small :color="item.empresaColor" label dark>{{
                          item.empresaShort
                        }}</v-chip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>

              <v-card-actions>
                <v-container fluid>
                  <v-row>
                    <v-col cols="3">
                      <v-btn
                        color="info"
                        v-if="records.length > 0"
                        :disabled="loading"
                        @click="imprimir"
                        >Imprimir Listado</v-btn
                      >
                    </v-col>
                    <v-col cols="3">
                      <v-btn
                        color="info"
                        v-if="habilitarImprimirRemito > 0"
                        :disabled="loading"
                        @click="imprimirRemito"
                        >Imprimir Remito</v-btn
                      >
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="3">
                      <v-btn
                        color="info"
                        v-if="habilitarCambioEstadoMasivo"
                        :disabled="loading"
                        @click="cambioEstadoMasivo()"
                        >Pasar Créditos a Para Transferir</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-flex>
          </v-layout>
          <template v-if="$store.state.debugModeOn">
            Debug Info:
            <p></p>

            Model: {{ filtro }}
            <p></p>
          </template>
          <v-divider></v-divider>
        </v-card-text>
      </v-card>

      <!-- variables motor -->
      <v-dialog v-model="showVariablesMotor" width="1000">
        <app-variables-motor
          :ConsultaMotorId="ejecucionMotorId"
        ></app-variables-motor>
      </v-dialog>
    </v-container>
  </v-app>
</template>

<script>
import { http } from '@/axios';
import Vue from 'vue';
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

export default {
  data() {
    return {
      primeraBusquedaRealizada: false,
      loading: false,
      editMode: false,
      suspend: false,
      pagination: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [''],
        page: 1,
        itemsPerPage: 5,
      },
      footer: {
        showFirstLastPage: true,
        itemsPerPageOptions: [5, 10, 20, 50],
      },
      totalItems: 0, // va afuera de pagination
      records: [], // registros
      selectedCreditos: [],
      filtro: {
        sucursalId: 0,
        canalVentaId: 0,
        productoId: 0,
        subestados: [],
        canalesVenta: [],
        tipoCanalVentaId: 0,
        tipoEstadoLegajoDigitalId: 0,
        tipoEstadoProductoDirigidoId: 0,
        periodo: {},
        filtrarUltimaActualizacion: false,
        periodoActualizacion: { id: 1 },
      },
      canalesVenta: [],
      sucursales: [],
      productos: [],
      subestados: [],
      usuario: [],
      tiposCanalVenta: [],
      tiposEstadoLegajoDigital: [],
      tiposEstadoProductoDirigido: [],
      showImpresionFormularios: true,
      accionesMasivas: false,
      operacionesParaLiquidarBuscadas: false,
      operacionaActivasBuscadas: false,
      showVariablesMotor: false,
      ejecucionMotorId: 0,
      cargaCanalesVenta: false,
      muestraFiltroCanalesVenta: true,
    };
  },
  async created() {
    this.loadSucursales();
    
    if(!this.$store.state.user.accesoTodosCanalesVenta){      
      this.cargarCanalesVenta();}
    else
      this.canalesVenta.push("(Todos)");

    this.loadProductos();
    this.loadSubEstados();
    this.loadTiposCanalVenta();
    this.loadTiposEstadoLegajoDigital();
    this.loadTiposEstadoProductoDirigido();
  },
  watch: {
    pagination: {
      handler() {
        if (this.primeraBusquedaRealizada) this.getItems();
      },
      deep: true,
    },
    accionesMasivas: {
      handler() {
        if (!this.accionesMasivas) this.selectedCreditos = [];
      },
    },
  },
  computed: {
    ...mapGetters([
      'checkCanCreate',
      'checkCanUpdate',
      'checkCanDelete',
      'checkCanAccess',
      'getActionFromLink',
      'error',
      'user',
    ]),
    canCreate: function() {
      return this.checkCanCreate(this.$route.path);
    },
    canUpdate: function() {
      return this.checkCanUpdate(this.$route.path);
    },
    canDelete: function() {
      return this.checkCanDelete(this.$route.path);
    },
    action: function() {
      return this.getActionFromLink(this.$route.path);
    },
    habilitarCambioEstadoMasivo() {
      return (
        this.operacionesParaLiquidarBuscadas &&
        this.accionesMasivas &&
        this.records.length > 0 &&
        this.checkCanAccess('ap-pase-transferencia-masivo')
      );
    },
    habilitarImprimirRemito() {
      return (
        this.operacionaActivasBuscadas &&
        this.accionesMasivas &&
        this.records.length > 0 &&
        this.user.esComer
      );
    },
    deshabilitarConsultar: function() {
      return (
        this.loading || !this.canalesVenta || this.canalesVenta.length == 0
      );
    },
    todosLosSubEstadosMarcados() {
      return this.filtro.subestados.length === this.subestados.length;
    },
    algunosSubEstadosMarcados() {
      return (
        this.filtro.subestados.length > 0 && !this.todosLosSubEstadosMarcados
      );
    },
    iconSubestados() {
      if (this.todosLosSubEstadosMarcados) return 'mdi-close-box';
      if (this.algunosSubEstadosMarcados) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },

    todosLosCanalesVentaMarcados() {
      return this.filtro.canalesVenta.length === this.canalesVenta.length;
    },
    algunosCanalesVentaMarcados() {
      return (
        this.filtro.canalesVenta.length > 0 &&
        !this.todosLosCanalesVentaMarcados
      );
    },
    iconCanalesVenta() {
      if (this.todosLosCanalesVentaMarcados) return 'mdi-close-box';
      if (this.algunosCanalesVentaMarcados) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
    headers() {
      // definición de columnas
      var headers = [];

      headers.push({
        text: 'Acciones',
        value: 'accion',
        width: 80,
        sortable: false,
      });
      headers.push({ text: 'Origen del Crédito', value: 'origen' });
      if (!this.habilitarCambioEstadoMasivo)
        headers.push({ text: 'Estado', value: 'subestado' });

      headers.push({ text: 'Procedencia', value: 'origenId' });

      if (
        this.$store.state.parametrosGenerales.ingresoPorDefectoPor ==
        'documento'
      )
        headers.push({ text: 'Documento', value: 'documento' });
      else headers.push({ text: 'Cuil', value: 'cuil' });

      headers.push({ text: 'Solicitante del Crédito', value: 'solicitante' });
      headers.push({ text: 'Crédito Nº', value: 'numero' });
      headers.push({ text: 'Monto', value: 'monto', width: 120 });
      headers.push({ text: 'Cuotas', value: 'cuotas' });
      headers.push({
        text: 'Fecha de Ingreso',
        value: 'fechaIngreso',
        width: 120,
      });

      if (!this.habilitarCambioEstadoMasivo)
        headers.push({
          text: 'Fecha de Liquidación',
          value: 'fechaLiquidacion',
          width: 120,
        });

      headers.push({ text: 'Analista', value: 'analista' });

      headers.push({
        text: 'Pasó por Motor',
        value: 'motorSiisa',
        sortable: false,
      });
      headers.push({ text: 'Pasó por Gueno', value: 'vieneDeGueno' });

      if (this.$store.state.parametrosGenerales.auditoriaLegajoFisico)
        headers.push({
          text: 'Legajo Físico',
          value: 'estadoLegajoOriginal',
          sortable: false,
        });

      if (this.$store.state.parametrosGenerales.auditoriaLegajoDigital)
        headers.push({
          text: 'Legajo Digital',
          value: 'estadoValidacionDigital',
          sortable: false,
        });

      headers.push({
        text: 'Estado Dirigido',
        value: 'estadoProductoDirigido',
        sortable: false,
      });

      if (this.habilitarCambioEstadoMasivo) {
        headers.push({ text: 'Situación', value: 'situacionCredito' });
        headers.push({ text: '$ Reno/Refi', value: 'importeRenovacion' });
        headers.push({ text: '$ A Transferir', value: 'importeATransferir' });
      }
      headers.push({ text: 'Teléfono', value: 'celular', width: 100 });
      headers.push({ text: '', value: 'imprimir', sortable: false });
      headers.push({ text: 'Empresa', value: 'empresaNombre', width: 100 });

      //

      return headers;
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'setActiveSubTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
      'setReporteActivo',
    ]),
    ...mapActions(['setStatusTareaFrecuente']),

    async cargarCanalesVenta() {
      this.loadCanalesVenta();
      //this.canalesVenta.push('(Todos)');
      this.muestraFiltroCanalesVenta = false;
      this.cargaCanalesVenta = true;      
    },

    async getItems(resetPagination) {
      if (this.filtro.periodo.desde === undefined) {
        this.alertWarning('Debe elegir un periodo para la búsqueda.');
        return;
      }
      //Charlie
      // if (!this.canalesVenta || this.canalesVenta.length == 0) {
      //   this.alertWarning(
      //     "Por favor, espere a que las listas terminen de cargarse antes de realizar la consulta."
      //   );
      //   return;
      // }

      //Hago esto para que si cambias los filtros y tocas consultar traiga los resultados de la primera página
      if (resetPagination) {
        this.pagination.page = 1;
      }

      this.loading = true;
      this.$validator.reset();

      if(!this.$store.state.user.accesoTodosCanalesVenta && this.filtro.canalesVenta.length == 0){
        await this.toggleCanalesVenta();
      }


      let filter = this.filtro;
      let idCanalesVenta = filter.canalVentaId.toString();
      //Si se eligió TODOS ( y no tiene acceso a todos los canales) armo un string con todos los canales de venta habilitados para el usuario.
      if (
        //filter.canalVentaId === 0
        this.todosLosCanalesVentaMarcados &&
        !this.$store.state.user.accesoTodosCanalesVenta
      ) {
        for (var i = 0; i < this.canalesVenta.length; i++) {
          if (i === 0) idCanalesVenta = this.canalesVenta[i].id;
          else idCanalesVenta += ',' + this.canalesVenta[i].id;
        }
      } else {
        if (this.todosLosCanalesVentaMarcados) idCanalesVenta = 0;
        else idCanalesVenta = filter.canalesVenta;
      }

      // si marco todos que mande 0, si no que mande la lista como ahora

      let loginUsuarioAlta = '(Todos)';
      //Si el usuario es comer y no es concentrador solo permite ver los créditos que dio de alta
      if (this.user.esComer && !this.user.esConcentrador)
        loginUsuarioAlta = this.user.login;

      console.log(filter);

      //idCanalesVenta = "0";
      if (idCanalesVenta == null || idCanalesVenta == '') {
        idCanalesVenta = '0';
      }

      try {
        var result = await http.get(
          'creditos/listcreditosotorgados?sucursalId=' +
            filter.sucursalId +
            '&canalesVenta=' +
            idCanalesVenta +
            '&productoId=' +
            filter.productoId +
            '&subEstadosId=' +
            filter.subestados +
            '&tipoCanalVentaId=' +
            filter.tipoCanalVentaId +
            '&documento=' +
            filter.documento +
            '&fechaDesde=' +
            filter.periodo.desde +
            '&fechaHasta=' +
            filter.periodo.hasta +
            '&loginUsuarioAlta=' +
            loginUsuarioAlta +
            '&tipoEstadoLegajoDigitalId=' +
            filter.tipoEstadoLegajoDigitalId +
            '&tipoEstadoProductoDirigidoId=' +
            filter.tipoEstadoProductoDirigidoId +
            '&filtrarUltimaActualizacion=' +
            filter.filtrarUltimaActualizacion +
            '&ultimaActualizacionDesde=' +
            filter.periodoActualizacion.desde +
            '&ultimaActualizacionHasta=' +
            filter.periodoActualizacion.hasta +
            '&limit=' +
            this.pagination.itemsPerPage +
            '&page=' +
            this.pagination.page +
            '&sortby=' +
            this.pagination.sortBy +
            '&descending=' +
            (this.pagination.sortDesc.length > 0
              ? this.pagination.sortDesc
              : 'false')
        );

        this.records = result.list;
        this.totalItems = result.totalCount;
        this.selectedCreditos = [];
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.operacionesParaLiquidarBuscadas =
        filter.subestados.length == 1 && filter.subestados[0] == 52; //le pongo true si en el filtro está solo el subestado Para Liquidar
      this.operacionaActivasBuscadas =
        filter.subestados.length == 1 &&
        filter.subestados[0] > 100 &&
        filter.subestados[0] < 300; //le pongro true si el filtro esta en un subestado de credito activo
      this.loading = false;
      this.primeraBusquedaRealizada = true;
    },
    async resetState() {
      this.$validator.reset();
      this.editMode = false;
    },
    async loadProductos() {
      this.loading = true;
      try {
        var result = await http.get('productos/');

        this.productos = result.list;

        this.productos.unshift({ id: 0, descripcion: '(Todos)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSucursales() {
      this.loading = true;
      try {
        var result = await http.get(
          'sucursales/list/porusuario?usuarioId=' + this.user.id
        );

        this.sucursales = result.list;

        this.sucursales.unshift({ id: 0, nombre: '(Todas)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesVenta() {
      this.loading = true;
      try {
        var result = await http.get(
          'canalesventa/habilitadosparausuario?usuarioId=' + this.user.id
        );

        this.canalesVenta = result.list;

        //this.canalesVenta.unshift({ id: 0, nombre: '(Todos)' });
        this.toggleCanalesVenta();
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    toggleCanalesVenta() {
  return new Promise((resolve) => {
    this.$nextTick(() => {
      if (this.todosLosCanalesVentaMarcados) {
        this.filtro.canalesVenta = [];
      } else {
        this.filtro.canalesVenta = this.canalesVenta.map((p) => p.id);
      }
      resolve(); // Indica que los cambios están listos
    });
  });
},

    async loadSubEstados() {
      this.loading = true;
      try {
        var result = await http.get(
          'tipossubestadocredito?estadosParaActivar=false&estadosActivos=true'
        );

        this.subestados = result.list;

        // // elimino el subestado 59 ya que solo debe aparecer en bandeja de comercios
        // var index = this.subestados.findIndex((x) => x.id === 59);
        // this.subestados.splice(index, 1);

        this.toggleSubestados();
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    toggleSubestados() {
      this.$nextTick(() => {
        if (this.todosLosSubEstadosMarcados) {
          this.filtro.subestados = [];
        } else {
          this.filtro.subestados = this.subestados.map(function(p) {
            return p.id;
          });
        }
      });
    },
    async finAnalisis() {},
    async loadTiposEstadoLegajoDigital() {
      this.loading = true;
      try {
        var result = await http.get('tiposestadolegajodigital'); // traigo todas
        this.tiposEstadoLegajoDigital = result.list;
        this.tiposEstadoLegajoDigital.unshift({
          id: 0,
          descripcion: '(Todos)',
        });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposEstadoProductoDirigido() {
      this.loading = true;
      try {
        var result = await http.get('tiposestadoproductodirigido'); // traigo todas
        this.tiposEstadoProductoDirigido = result.list;
        this.tiposEstadoProductoDirigido.unshift({
          id: 0,
          descripcion: '(Todos)',
        });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    imprimir() {
      let filter = this.filtro;

      // COMENTADO POR CAMBIO DE SELECT
      let idCanalesVenta = filter.canalVentaId.toString();

      //Si se eligió TODOS ( y no tiene acceso a todos los canaes) armo un string con todos los canales de venta habilitados para el usuario.
      if (
        filter.canalVentaId === 0 &&
        //this.this.todosLosCanalesVentaMarcados
        !this.$store.state.user.accesoTodosCanalesVenta
      ) {
        for (var i = 0; i < this.canalesVenta.length; i++) {
          if (i === 0) idCanalesVenta = this.canalesVenta[i].id;
          else idCanalesVenta += ',' + this.canalesVenta[i].id;
        }
      } else {
        if (this.todosLosCanalesVentaMarcados) idCanalesVenta = 0;
        else idCanalesVenta = filter.canalesVenta;
      }

      let params = [];
      params.push({
        Version: this.$store.state.version,
        CanalesVenta: idCanalesVenta, // CanalesVenta
        SucursalId: filter.sucursalId, // SucursalId
        ProductoId: filter.productoId, // ProductoId
        SubEstadoId: filter.subEstadoId, // SubEstadoId
        IngresoDesde: filter.periodo.desde, // IngresoDesde
        IngresoHasta: filter.periodo.hasta, // IngresoHasta
        Documento: '', // Documento
        SubEstados: filter.subestados.join(','),
        //CanalesVenta: filter.canalVenta.join(','),
      });

      this.setReporteActivo({
        reporte: 'Listado de Creditos.trdp',
        params: params,
      });

      window.open('/report-viewer');
    },
    async cambioEstadoMasivo() {
      if (this.selectedCreditos.length == 0) {
        this.alertWarning(
          'Debe marcar los créditos que desea cambiar de estado.'
        );
        return;
      }

      if (
        confirm(
          'Los ' +
            this.selectedCreditos.length +
            ' créditos marcados pasarán a estado Para Transferir ¿Desea confirmar?'
        )
      ) {
        this.loading = true;
        try {
          var params = {};
          params.creditosId = this.selectedCreditos.map((x) => x.id);
          params.nuevoSubEstadoId = 58; //para transferir

          await http.post(
            'creditos/cambiarestadomasivo',
            JSON.stringify({ parametros: params })
          );

          await this.alertSuccess(
            'Se ha modificado el estado de los créditos.'
          );
          this.selectedCreditos = [];
          this.getItems(false);
        } catch (error) {
          // Error
          this.alertError(error);
        }
        this.loading = false;
      }
    },
    async imprimirRemito() {
      if (
        confirm(
          'Se generará el listado con los ' +
            this.selectedCreditos.length +
            ' créditos marcados. ¿Desea confirmar?'
        )
      ) {
        let params = [];
        //let canalVenta = this.canalesVenta.find(cv => cv.id > 0== this.filtro.canalVentaId);
        let canalVenta = this.canalesVenta.find((cv) => cv.id > 0); // busco el primero que tenga id > 0 porque en teoria van a tener un solo canal de venta habilitado los comer

        params.push({
          Version: 'beta-0.1.0', // version

          IdCreditos: this.selectedCreditos.map((x) => x.id).join(),
          Usuario: this.user.login,
          CanalVenta: canalVenta.nombre,
        });

        this.setReporteActivo({
          reporte: 'Reporte Remito.trdp',
          params: params,
        });

        window.open('/report-viewer');
      }
    },
    async loadTiposCanalVenta() {
      this.loading = true;
      try {
        var result = await http.get('tiposcanalventa');
        this.tiposCanalVenta = result.list;
        this.tiposCanalVenta.unshift({ id: 0, descripcion: '(Todos)' });
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
  },
};
</script>
